if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


//Quantity selector
let qty_input = document.querySelector('#select-4');
const set_qty = event => {
  const btn = event.target.querySelector('.select__toggle');
  // выбранный текст опции
  const selected = event.target.querySelector('.select__option_selected');
  const text = selected ? selected.textContent : '';
  document.querySelector('input#quantity').setAttribute('value', text)
}
qty_input.addEventListener('select.change', set_qty);


//Variant selector

let product_json = JSON.parse(document.querySelector('#data-json').textContent);
let selectors = document.querySelectorAll('.variant__selectors .select:not(#select-4)');
let variant_selects = document.querySelector('.variant__selectors');
let main_info = document.querySelector('.product__info-wrapper.grid__item.product__info-wrapper--extra-padding');
let loading_spinner = document.querySelector('.loading__spinner');
let filtered_varinats = [];
let selected_variant;
let featured_image;
let featured_image_id;
let availability;


const update_URL = () => {
  window.history.replaceState({ }, '', `${variant_selects.dataset.url}?variant=${get_id()}`);
}

const get_current_variant = event => {
  let option1 = document.querySelector('#select-1 .select__toggle ') ? document.querySelector('#select-1 .select__toggle ').textContent.replace(/\s+/g, '') : '';
  let option2 = document.querySelector('#select-2 .select__toggle ') ? "/" + document.querySelector('#select-2 .select__toggle ').textContent.replace(/\s+/g, '') : '';
  let option3 = document.querySelector('#select-3 .select__toggle ') ? "/" + document.querySelector('#select-3 .select__toggle ').textContent.replace(/\s+/g, '') : '';
  let options_title = `${option1}${option2}${option3}`;
  document.querySelectorAll('.color__swatches input').forEach(el => {
    if (el.value == option1){
      el.setAttribute('checked','checked')
    }else{
      el.removeAttribute('checked')
    }
  })

  for (const [key, value] of Object.entries(product_json.variants) ) {
    if (!value.featured_image || value.featured_image == null ){
      filtered_varinats.push([value.title, value.id, null, null ,value.available])
    }else{
      filtered_varinats.push([value.title, value.id, value.featured_image.src, value.featured_media.id ,value.available])
    }
    
  }
  for (let variant of filtered_varinats){
    let title = variant[0].replace(/\s+/g, '');
    if (title == options_title){
      selected_variant = variant[1];
      featured_image = variant[2];
      featured_image_id = variant[3];
      availability = variant[4];
    }   
  }
}

const set_variant = event => {
  get_current_variant();
  document.querySelector('input#variant_id').setAttribute('value', selected_variant);  
}

const get_id = () => {
  let id = parseInt(document.getElementById('variant_id').getAttribute('value'));
  return id
}


const toggle_add_button = (disable = true, text, modifyClass = true) =>{
  const productForm = document.getElementById(`product-form-main`);
  if (!productForm) return;
  const addButton = productForm.querySelector('[name="add"]');
  const addButtonText = productForm.querySelector('[name="add"] > span');

  if (!addButton) return;

  if (disable) {
    addButton.setAttribute('disabled', 'disabled');
    if (text) addButtonText.textContent = text;
  } else {
    addButton.removeAttribute('disabled');
    addButtonText.textContent = window.variantStrings.addToCart;
  }

  if (!modifyClass) return;
}

const set_unavailable = () => {
  const button = document.getElementById(`product-form-${variant_selects.dataset.section}`);
  const addButton = button.querySelector('[name="add"]');
  const addButtonText = button.querySelector('[name="add"] > span');
  const price = document.getElementById(`price-${variant_selects.dataset.section}`);
  if (!addButton) return;
  addButtonText.textContent = window.variantStrings.unavailable;
  if (price) price.classList.add('visibility-hidden');
}

const render_price = (responseText) => {
  const product_price = `.price.price--large`;
  const html = new DOMParser().parseFromString(responseText, 'text/html')
  const destination = document.querySelector(product_price);
  const source = html.querySelector(product_price);

  if (source && destination) destination.innerHTML = source.innerHTML;

  const price = document.getElementById(`price-${variant_selects.dataset.section}`);

  if (price) price.classList.remove('visibility-hidden');
}

const render_metafields = (responseText) => {
  const product_dimensions = `.product__dimensions`;
  const html = new DOMParser().parseFromString(responseText, 'text/html')
  const destination = document.querySelector(product_dimensions);
  const source = html.querySelector(product_dimensions);
  if (source && destination) destination.innerHTML = source.innerHTML;
}


const render_availability = (responseText) => {
  const availiblity_status = `.availiblity__status `;
  const html = new DOMParser().parseFromString(responseText, 'text/html')
  const destination = document.querySelector(availiblity_status);
  const source = html.querySelector(availiblity_status);
  if (source && destination) destination.innerHTML = source.innerHTML;
}



const render_product_info = () => {
  loading_spinner.classList.add('active')
  fetch(`${variant_selects.dataset.url}?variant=${get_id()}&section_id=${variant_selects.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      render_price(responseText);
      render_availability(responseText);
      render_metafields(responseText);
      toggle_add_button(!availability, window.variantStrings.soldOut);
    }).finally(()=>{
      loading_spinner.classList.remove('active');
    })
}

const update_media = () =>{
  if (!featured_image || featured_image == null) return;

  const mediaGallery = document.querySelector('.main__product-gallery');
  mediaGallery.setActiveMedia(`${variant_selects.dataset.section}-${featured_image_id}`, true);
  const modalContent = document.querySelector(`#ProductModal-${variant_selects.dataset.section} .product-media-modal__content`);
  const newMediaModal = modalContent.querySelector( `[data-media-id="${featured_image_id}"]`);
  modalContent.prepend(newMediaModal);
}

const on_variant_change = () =>{
  set_variant();
  update_URL();
  render_product_info();
  update_media();
  toggle_add_button(true, '', false);
}

selectors.forEach(s => s.addEventListener('select.change', on_variant_change));


//Color selector
let color_labels = document.querySelectorAll('.color__swatches label');

const set_color_variant = event => {
  let color = event.target.closest('label').dataset.value;
  document.querySelectorAll('.color__swatches input').forEach(el => el.removeAttribute('checked'));
  event.target.closest('label').previousElementSibling.setAttribute('checked','checked');
  selectors.forEach(el => {
    if(el.querySelector('.select__label').textContent.indexOf('Colo') > -1){
      el.querySelector('.select__toggle').textContent = color;
      el.querySelectorAll('.select__option').forEach(li => {
        if (li.textContent.indexOf(color) > -1){
          li.classList.add('select__item_selected', 'select__option_selected');
        }else{
          li.classList.remove('select__item_selected', 'select__option_selected');
        }
      })
    }
  })
  on_variant_change();
}

color_labels.forEach(c => c.addEventListener('click', set_color_variant));

//Update variant selectors info
const update_selectors = event => {
  let option1, option2, option3;
  let variant_id = get_id();
  for (let [key, value] of Object.entries(product_json.variants)){
    if (value.id == variant_id){
      option1 = value.option1;
      option2 = value.option2 ? value.option2 : false;
      option3 = value.option3 ? value.option3 : false;
    }
  }
  selectors.forEach(function(el, index, array) {
    
    el.querySelectorAll('.select__options li').forEach(li => {
      if (index == 0){
        li.closest('.select__dropdown').previousElementSibling.innerHTML = option1;
        if (li.textContent == option1)   {
          li.classList.add('select__item_selected', 'select__option_selected')
        }  else{
          li.classList.remove('select__item_selected', 'select__option_selected')
        } 
      }else if (index == 1){
        li.closest('.select__dropdown').previousElementSibling.innerHTML = option2;
        if (li.textContent == option2)   {
          li.classList.add('select__item_selected', 'select__option_selected')
        }  else{
          li.classList.remove('select__item_selected', 'select__option_selected')
        } 
      }else {
        li.closest('.select__dropdown').previousElementSibling.innerHTML = option3;
        if (li.textContent == option3)   {
          li.classList.add('select__item_selected', 'select__option_selected')
        }  else{
          li.classList.remove('select__item_selected', 'select__option_selected')
        } 
      } 
    });
  });

}

if (location.href.indexOf('?variant=') > -1){
  update_selectors();
}




//------------------------------------------------------------------------------//
